// IMPORTANT: Note that with Redux, state should NEVER be changed.
import objectAssign from 'object-assign';
import { navigationInitialState } from '../store/initialState';
import { combineReducers } from 'redux';
import { PAGE_CHANGED, PREVIOUS_PAGE } from '../actions/navigationBar.js';

const reducer = (state = navigationInitialState, action) => {
  switch (action.type) {
    case PAGE_CHANGED:
      return objectAssign({}, state, {
        currentPageTitle: action.data,
      });
    case PREVIOUS_PAGE:
      return objectAssign({}, state, {
        previousPage: action.data,
      });
    default:
      return state;
  }
};
export default reducer;
